import { apiSlice } from "@/shared/api/apiSlice";

type GetCatalogFaqRquest = {
    id: string
}

export const catalogFaqApi = apiSlice.injectEndpoints({
    endpoints: build => ({
        getCatalogFaq: build.query<any, GetCatalogFaqRquest>({
            query: ({ id }) => ({
                url: `/categories/faq/${id}`
            }),
            transformResponse: result => result['data']
        })
    })
})